module.exports = __webpack_public_path__ + "static/media/CONTRATO_ESOLUTION.fcac11a0.pdf";